<template>
<div>
    <el-select v-if="isEditing" v-model="selectedWeChatType" @change="onWeChatTypeChanged" placeholder="请选择" size="mini">
        <el-option v-for="item in weChatTypeList" :key="item.Id" :label="item.Name" :value="item.Id">
        </el-option>
    </el-select>
    <span v-if="!isEditing" :class="selectedWeChatTypeName == '未进群'?'red':''">
        {{selectedWeChatTypeName}}
    </span>
</div>
</template>

<style lang="scss" scoped>
.red {
    color: red
}
</style>

<script>
import {
    saveWeChatTypeChange
} from "../../../service/finance.service.js"
export default {
    props: {
        data: {},
        columnData: {},
        status: {},
        editLocation: {},
    },
    data() {
        return {
            weChatTypeList: [{
                Id: 0,
                Name: "未进群"
            }, {
                Id: 1,
                Name: "已进群"
            }, {
                Id: 2,
                Name: "已退群"
            }],
            selectedWeChatType: 0,
            selectedWeChatTypeName: "",
            isEditing: false,
            originalWeChatType: 0,
            originaWeChatTypeName: ""
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            this.selectedWeChatType = this.data.WeChatGroupType;
            this.selectedWeChatTypeName = this.data.WeChatGroupTypeText;
            this.originalWeChatType = this.selectedWeChatType;
            this.selectedWeChatTypeName = this.selectedWeChatTypeName;
        },
        onWeChatTypeChanged() {
            let self = this;
            saveWeChatTypeChange(this.data.Id, this.selectedWeChatType)
                .then(result => {
                    if (!!result && result.success) {
                        this.$message({
                            type: 'success',
                            message: '排课状态更新成功!'
                        });
                        self.originalWeChatType = self.selectedWeChatType;
                        self.selectedWeChatTypeName = self.weChatTypeList.filter(i => i.Id == self.selectedWeChatType)[0].Name;
                        self.Reset();
                    } else {
                        self.Reset();
                        this.$message({
                            type: 'error',
                            message: '排课状态更新失败! ' + result.message
                        });
                    }
                })
        },
        Reset() {
            this.isEditing = false;
            this.selectedWeChatType = this.originalWeChatType;
            this.selectedWeChatTypeName = this.selectedWeChatTypeName;
        }
    },
    watch: {
        editLocation: function () {
            if (this.data.IsRefund){
                return;
            }
           
            if (this.editLocation && this.editLocation.columnLabel == "排课" && this.editLocation.rowIndex == this.data.Index) {
                this.isEditing = true;
            } else {
                this.isEditing = false;
            }
        },
        data: function () {
            this.init();
        },
        status: function () {}
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/saleQueryWeChatCell.vue